import startOfDay from 'date-fns/startOfDay'

export interface IAvailableDays {
  days: Map<string, number>
}

export interface IAvailableDaysFactory extends  IAvailableDays {
}

export interface IDay {

}

export class AvailableDays {
  days: Map<string, number>
  _ordersCountForDaysAfterTomorrow: number|null = null

  constructor(availableDaysData: IAvailableDays) {
    this.days = availableDaysData.days
  }

  getOrdersCountByDate(date: Date): number {
    const foundDay = this.days.get(startOfDay(date).toString())
    if (!foundDay) {
      return 0
    }

    return foundDay
  }

  getOrdersCountForDaysAfterTomorrow(): number {
    if (this._ordersCountForDaysAfterTomorrow !== null) {
      return this._ordersCountForDaysAfterTomorrow
    }

    const today = startOfDay(new Date())
    const tomorrow = startOfDay(new Date(today))
    tomorrow.setDate(tomorrow.getDate() + 1)

    const daysAfterTomorrow = new Map(this.days)
    daysAfterTomorrow.delete(today.toString())
    daysAfterTomorrow.delete(tomorrow.toString())

    daysAfterTomorrow.forEach((ordersCount) =>
      this._ordersCountForDaysAfterTomorrow = (this._ordersCountForDaysAfterTomorrow || 0) + ordersCount
    )

    return this._ordersCountForDaysAfterTomorrow || 0
  }

  hasOrders(date: Date): boolean {
    return Boolean(this.getOrdersCountByDate(date))
  }
}

export const createAvailableDays = (availableDaysData: IAvailableDaysFactory): AvailableDays => {

  return new AvailableDays({
    ...availableDaysData,
  })
}
